// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"5700ef63","79":"764a3691","109":"ad204922","185":"9a1f70d7","285":"7c567a04","667":"badc349c","974":"4ff47313"}[chunkId] + ".js";
};